/**
 * CTA (Call to Action) section component for Stack Forward website
 */

import React from 'react';

/**
 * CTA section component
 */
export const CTA: React.FC = () => {
  // Handle CTA click
  const handleCTAClick = () => {
    const contactSection = document.querySelector('#contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="why-open-source" className="section bg-neutral-900 text-white">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
          {/* Main content */}
          <div className="mb-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
              Own Your Stack. Cut License Costs. Keep Control.
            </h2>
            <p className="text-xl md:text-2xl text-neutral-300 mb-8 leading-relaxed">
              Stop paying expensive licensing fees for proprietary software.
              Open-source solutions give you the same functionality with
              complete control over your data and infrastructure.
            </p>
          </div>

          {/* Benefits grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center text-2xl mb-4 mx-auto">
                💰
              </div>
              <h3 className="text-xl font-semibold mb-3">Reduce Costs</h3>
              <p className="text-neutral-300">
                Eliminate expensive licensing fees and reduce your total cost of
                ownership by up to 70%.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center text-2xl mb-4 mx-auto">
                🔒
              </div>
              <h3 className="text-xl font-semibold mb-3">Enhanced Security</h3>
              <p className="text-neutral-300">
                Keep your data on-premises with full control over security
                policies and compliance requirements.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center text-2xl mb-4 mx-auto">
                🚀
              </div>
              <h3 className="text-xl font-semibold mb-3">Future-Proof</h3>
              <p className="text-neutral-300">
                Avoid vendor lock-in and customize solutions to grow with your
                business needs.
              </p>
            </div>
          </div>

          {/* Statistics */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary-400 mb-2">
                70%
              </div>
              <div className="text-sm text-neutral-400 uppercase tracking-wide">
                Cost Reduction
              </div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary-400 mb-2">
                50+
              </div>
              <div className="text-sm text-neutral-400 uppercase tracking-wide">
                Projects Delivered
              </div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary-400 mb-2">
                24/7
              </div>
              <div className="text-sm text-neutral-400 uppercase tracking-wide">
                Support Available
              </div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary-400 mb-2">
                5+
              </div>
              <div className="text-sm text-neutral-400 uppercase tracking-wide">
                Years Experience
              </div>
            </div>
          </div>

          {/* Main CTA */}
          <div className="space-y-6">
            <button
              onClick={handleCTAClick}
              className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
            >
              Get Your Free Technical Assessment
            </button>

            <p className="text-neutral-400 text-sm">
              No commitment required • 30-minute consultation • Custom
              recommendations
            </p>
          </div>

          {/* Trust indicators */}
          <div className="mt-16 pt-8 border-t border-neutral-800">
            <p className="text-neutral-400 text-sm mb-4">
              Trusted by teams across the Middle East and India
            </p>
            <div className="flex justify-center items-center space-x-8 opacity-60">
              <div className="text-sm font-medium text-neutral-500">
                Manufacturing
              </div>
              <div className="text-sm font-medium text-neutral-500">
                Healthcare
              </div>
              <div className="text-sm font-medium text-neutral-500">
                Finance
              </div>
              <div className="text-sm font-medium text-neutral-500">
                Government
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
